import { render, staticRenderFns } from "./InscricaoFederal.vue?vue&type=template&id=331d40a5"
import script from "./InscricaoFederal.vue?vue&type=script&lang=js"
export * from "./InscricaoFederal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports